@if (!reloading) {
  <div>
    @if (!initializing) {
      <ng-content></ng-content>
    }
    @if (loading || initializing) {
      <div class="loader-container">
        <div class="inline-loader"></div>
      </div>
    }
    @if (loading) {
      <span class="loader-text">{{ loadingText }}</span>
    }
  </div>
} @else {
  <app-infinite-progress
    [inProgress]="true"
    [label]="reloadingText"
  ></app-infinite-progress>
}
